import template from './asset-details.component.html';
import assetImageEditTemplate from './images/asset-image-edit.modal.html';
import assetImageUploadTemplate from './images/asset-image-upload.modal.html';
import assetImageViewTemplate from '../../../components/images-modal/equipment-images.modal.html';
import * as AssetDetailsActions from '../../../../state/asset-details/asset-details.actions';

// Constants
const EVENT_TRACKING_NAME = 'assetDetailsDetails';
const EVENT_TRACKING_ACTIONS = {
  addImage: 'addImage',
  uploadImage: 'uploadImage',
  deletedImage: 'deletedImage',
  cancelledModal: 'canceledModal',
  setDefaultImage: 'setDefaultImage',
}

class AssetDetailsController {
  constructor($uibModal, usersService, $ngRedux, syncRunHoursService) {
    'ngInject';
    this.store = $ngRedux;
    this.usersService = usersService;
    this.$uibModal = $uibModal;
    this.errorText = '';
    this.errorFlag = false;
    this.syncRunHoursService = syncRunHoursService;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(() => ({}), {...AssetDetailsActions})(this);
  }

  $onChanges(changes) {
    const {asset} = changes;
    const {attributes = [], images = [], users = [], profileImage} = asset.currentValue;
    this.attributes = attributes;
    this.images = images;
    this.users = users;
    this.profileImage = profileImage;
    this.showImageSection =
      this.usersService.hasRequiredFeatures(['images']) &&
      (this.usersService.hasRequiredFeatures(['assets.images']) || this.images.length > 0);
    this.runHoursSeries = this.asset.series.find(ser => ser.dataId === this.asset.syncRunHours);
  }
  $onDestroy() {
    this.unsubscribe();
  }

  onDeleteImage(imageId) {
    //refresh asset images
    //todo refresh asset images only
    this.getAssetData(this.asset.id);

    this.addToDataLayer({
      event: EVENT_TRACKING_ACTIONS.deletedImage,
      assetId: this.asset.id,
    })
  }

  addToDataLayer(data) {
    window.dataLayer.push({
      event: EVENT_TRACKING_NAME,
      data: { ...data }
    });
  }
  //************************* MODALS FOR IMAGES *************************

  //************************* EDIT *************************
  editImageModal(image) {
    const classRef = this;
    this.errorText = '';
    this.errorFlag = false;
    this.$uibModal
      .open({
        animation: true,
        size: 'md',
        template: assetImageEditTemplate,
        controller: 'AssetImageEditController',
        resolve: {
          image: () => image
        }
      })
      .result.then(function(response) {
        //if object is returned need to update the image in asset to the new name + description

        if (!response) {
          return;
        } else {
          //todo refresh asset images only
          classRef.getAssetData(classRef.asset.id);
        }
      })
      .catch(() => {});
  }
  //************************* VIEW *************************
  openImageModal(pictureIndex) {
    const classRef = this;
    this.errorText = '';
    this.errorFlag = false;
    const currentProfilePictureId = this.profileImage && this.profileImage.id ? this.profileImage.id : 0;
    this.$uibModal
      .open({
        animation: true,
        size: 'lg',
        template: assetImageViewTemplate,
        controller: 'EquipmentImagesModalController',
        resolve: {
          items: () => this.images,
          index: pictureIndex,
          users: () => this.users,
          equipId: () => this.asset.id,
          profilePictureId: () => currentProfilePictureId,
          onDeleteImageCallback: () => this.onDeleteImage.bind(this)
        }
      })
      .result.then(function(defaultImageId) {
        if (defaultImageId && defaultImageId !== currentProfilePictureId) {
          //todo apdate profile img
          //todo refresh asset images only
          classRef.getAssetData(classRef.asset.id);

          this.addToDataLayer({
            action: EVENT_TRACKING_ACTIONS.setDefaultImage,
          });
        }
      })
      .catch(() => {});
  }

  //************************* UPLOAD *************************
  uploadImage() {
    const classRef = this;
    this.errorText = '';
    this.errorFlag = false;

    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.addImage,
      assetId: this.asset.id,
    });

    this.$uibModal
      .open({
        animation: true,
        size: 'md',
        template: assetImageUploadTemplate,
        controller: 'AssetImageUploadController',
        resolve: {
          equipmentId: () => this.asset.id
        }
      })
      .result.then(function(response) {
        if (!response) {
          this.addToDataLayer({
            action: EVENT_TRACKING_ACTIONS.cancelledModal,
            assetId: this.asset.id,
          })
          return;
        }
        if (response.message) {
          classRef.errorText = response.message;
          classRef.errorFlag = true;
        } else if (response.data) {
          //todo refresh asset images only
          classRef.getAssetData(classRef.asset.id);

          this.addToDataLayer({
            action: EVENT_TRACKING_ACTIONS.uploadImage,
          });
        }
      })
      .catch(() => {});
  }
}

export default {
  template,
  controller: AssetDetailsController,
  //not useing vm as when using ui-route it is conflicting with parent vm
  //https://github.com/johnpapa/angular-styleguide/issues/577#issue-115275989
  controllerAs: 'detailVm',
  bindings: {
    asset: '<',
    loading: '<'
  }
};
